<div style="background: white" class="page-wrapper back">
  <div class="container-fluid">
    <button
      style="color: black; background-color: white"
      mat-mini-fab
      aria-label="Example icon button with a home icon"
      onclick="window.history.go(-1); return false;"
    >
      <mat-icon>arrow_back</mat-icon>
    </button>
    <div style="background: white" class="row page-titles">
      <div class="col-md-5 align-self-center">
        <h3 class="text-themecolor">Resumen de {{ text.casos }}</h3>
      </div>
      <div class="col-md-7 align-self-center">
        <ol class="breadcrumb">
          <li
            class="breadcrumb-item active"
            routerLink="/dashboard/inicio"
            style="cursor: pointer"
          >
            Inicio
          </li>
          <li
            class="breadcrumb-item active"
            class="breadcrumb-item active"
            routerLink="/dashboard/resumen"
          >
            Resumen
          </li>
        </ol>
      </div>
    </div>
    <h4 class="modal-title font-weight-bold" id="exampleModalLabel1">
      {{ text.Casos }} Archivados
    </h4>

    <div
      class="container"
      style="margin: 0px; max-width: 1230px; min-width: 800px"
    >
      <div class="row">
        <div class="col-12 mb-3">
          <div class="d-flex justify-content-center h-100">
            <div class="searchbar">
              <input
                class="search_input"
                type="text"
                [(ngModel)]="search"
                placeholder="Filtrar..."
              />
              <button class="search_icon" (click)="filterByClick()">
                <i class="fas fa-search"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="task_content_table example content-table">
        <table
          mat-table
          #dataTable
          [dataSource]="dataSource"
          matSort
          style="width: 100%; --min-width: 600px"
          class="task_table"
        >
          <ng-container matColumnDef="numero_caso">
            <th
              class="header-options"
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
            >
              Número de Caso
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.numero_caso }}
            </td>
          </ng-container>

          <ng-container matColumnDef="descripcion">
            <th
              class="header-options"
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
            >
              Descripción
            </th>
            <!-- <td (click)="element.ver = (element.ver == undefined?true:!element.ver)" style="cursor: pointer;display: flex;" mat-cell *matCellDef="let element">
                {{ element.ver?element.descripcion:element.descripcion.substring(0,40)  }} <p *ngIf="!element.ver && element.realizo.length > 40" style="color: #00a2ff;">...ver mas</p> 
              </td> -->
            <td
              style="word-break: break-all"
              (click)="
                element.ver = element.ver == undefined ? true : !element.ver
              "
              style="cursor: pointer; display: flex"
              mat-cell
              *matCellDef="let element"
            >
              {{
                element.ver
                  ? element.descripcion
                  : element.descripcion.substring(0, 40) + "..."
              }}
            </td>
          </ng-container>

          <ng-container matColumnDef="tipo_caso">
            <th
              class="header-options"
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
            >
              Tipo de Caso
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.tipo_caso }}
            </td>
          </ng-container>

          <ng-container matColumnDef="unidad">
            <th
              class="header-options"
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
            >
              Unidad
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.unidad }}
            </td>
          </ng-container>

          <ng-container matColumnDef="asignadoA">
            <th
              class="header-options"
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
            >
              Asignado A
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.asignadoA }}
            </td>
          </ng-container>

          <ng-container matColumnDef="creadoPor">
            <th
              class="header-options"
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
            >
              Creado Por
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.creadoPorc }}
            </td>
          </ng-container>

          <ng-container matColumnDef="createdAt">
            <th
              class="header-options"
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
            >
              Fecha de Creación
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.createdAt | date : "dd/MM/yyy" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="updatedAt">
            <th
              class="header-options"
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
            >
              Fecha de Finalizado
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.updatedAt | date : "dd/MM/yyy" }}
            </td>
          </ng-container>
          <!-- sadasd -->
          <ng-container
            *ngIf="filter_cases == 'Asuntos Externos'"
            matColumnDef="validar_documento"
          >
            <th
              class="header-options"
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
            >
              Documento valido
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.validar_documento }}
            </td>
          </ng-container>

          <ng-container
            *ngIf="filter_cases == 'Asuntos Externos'"
            matColumnDef="fecha_realizacion"
          >
            <th
              class="header-options"
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
            >
              Fecha realización
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.fecha_realizacion | date : "dd/MM/yyy" }}
            </td>
          </ng-container>

          <ng-container
            *ngIf="filter_cases == 'Asuntos Externos'"
            matColumnDef="email_usado"
          >
            <th
              class="header-options"
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
            >
              Email usado
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.email_usado }}
            </td>
          </ng-container>

          <ng-container
            *ngIf="filter_cases == 'Asuntos Externos'"
            matColumnDef="informado_correo"
          >
            <th
              class="header-options"
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
            >
              Informado al correo
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.informado_correo }}
            </td>
          </ng-container>

          <ng-container
            *ngIf="filter_cases == 'Asuntos Externos'"
            matColumnDef="autorizar"
          >
            <th
              class="header-options"
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
            >
              Autorizar
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.autorizar }}
            </td>
          </ng-container>

          <ng-container
            *ngIf="filter_cases == 'Asuntos Externos'"
            matColumnDef="patron_fraude"
          >
            <th
              class="header-options"
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
            >
              Patron de fraude
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.patron_fraude }}
            </td>
          </ng-container>
          <!-- adasdasd -->
          <ng-container matColumnDef="opciones">
            <th
              class="header-options"
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
            >
              Opciones
            </th>
            <td style="display: flex" mat-cell *matCellDef="let element">
              <button
                matTooltip="Ver historial"
                (click)="verHistorial(element)"
              >
                <mat-icon>receipt_long</mat-icon>
              </button>
              <button
                matTooltip="Ver detalles del caso"
                style="background: rgba(0, 0, 0, 0) !important"
                [routerLink]="'../detalle/' + element._id"
              >
                <mat-icon>visibility</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row></tr>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>
      <mat-paginator
        [pageSizeOptions]="[5, 10, 25, 50, 100]"
        [pageSize]="5"
        [showFirstLastButtons]
      ></mat-paginator>
    </div>
  </div>
</div>
